import { z } from 'zod'
import { afterValid } from '~/services/api/contracts/afterValid'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { StoreMenuCustomizationGroupRequestSchema } from '~/services/api/generated'
import { refineCustomizationGroupSelections } from '~/services/api/contracts/refineCustomizationGroupSelections'
import { customizationGroupFieldsNormalizer } from '~/services/api/contracts/normalizers/customizationGroupFieldsNormalizer'

const schema = StoreMenuCustomizationGroupRequestSchema.extend({
  linked_items: StoreMenuCustomizationGroupRequestSchema.shape.linked_items.unwrap().min(1),
  max_per_option: z.union([z.literal('Infinity'), z.int().positive()]).optional(),
  max_total_selections: z.union([z.literal('Infinity'), z.int().positive()]).optional()
}).strict()

export const MenuCustomizationGroupStore = (
  _context: NoContext
): z.ZodType<z.output<typeof schema>> =>
  afterValid(
    z.preprocess(customizationGroupFieldsNormalizer, schema),
    refineCustomizationGroupSelections
  )
